const FIELD_ALIGNMENT = {
  right: 'right',
  left: 'left',
};

Object.freeze(FIELD_ALIGNMENT);

export { FIELD_ALIGNMENT };
